import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-black bg-opacity-80 py-8 sm:py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-700">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          
          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
              📞 Contact Information
            </h3>
            <div className="space-y-3">
              <p className="text-gray-300 text-lg">
                <span className="text-green-400 font-semibold">Phone:</span> 9884899080
              </p>
              <p className="text-gray-300 text-lg">
                <span className="text-blue-400 font-semibold">Support:</span> support@yinguru.com
              </p>
            </div>
          </motion.div>

          {/* Policy Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-center md:text-left"
          >
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
              📋 Legal Policies
            </h3>
            <div className="space-y-3">
              <a 
                href="https://funnelsdone.com/terms" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-300 hover:text-green-400 transition-colors duration-300 text-lg"
              >
                Terms & Conditions
              </a>
              <a 
                href="https://funnelsdone.com/privacy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-300 hover:text-blue-400 transition-colors duration-300 text-lg"
              >
                Privacy Policy
              </a>
              <a 
                href="https://funnelsdone.com/refund-policy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-300 hover:text-yellow-400 transition-colors duration-300 text-lg"
              >
                Refund Policy
              </a>
            </div>
          </motion.div>

          {/* Company Information */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="text-center md:text-left lg:col-span-1 md:col-span-2 lg:col-span-1"
          >
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
              🏢 About AWA AI
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed mb-4">
              Complete WhatsApp automation solution designed specifically for Tamil business owners to scale their sales and customer engagement.
            </p>
            <div className="flex justify-center md:justify-start">
              <button
                onClick={() => window.open('https://abdul.cc/awaaipay', '_blank')}
                className="bg-green-500 hover:bg-green-400 text-black font-bold py-2 px-6 rounded-full transition-all duration-300 transform hover:scale-105"
              >
                Get Started 🚀
              </button>
            </div>
          </motion.div>
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="border-t border-gray-700 pt-6"
        >
          <div className="text-center">
            <p className="text-gray-400 text-base sm:text-lg mb-2">
              © 2025 Funnelsdone LLC and Goguru International Private Limited. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              AWA AI - Empowering Tamil businesses with intelligent WhatsApp automation
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;